__turbopack_context__.v({
  "active": "style-module-scss-module__C_JDCW__active",
  "button-group": "style-module-scss-module__C_JDCW__button-group",
});
